import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LandingPage from './components/LandingPage'
import AboutPage from './components/AboutPage'
import ServicesPage from './components/ServicesPage'
import ContactForm from './components/ContactForm'
import PortfolioPage from './components/PortfolioPage'
import OurProcessPage from './components/OurProcessPage'
import ScrollToTop from './components/ScrollToTop'
import './App.css'

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactForm />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/our-process" element={<OurProcessPage />} />
        </Routes>
      </div>
    </Router>
  )
}
export default App
